/* eslint-disable */
import React from "react";

interface IKnowledgeGraphJsonLdProps {
  schemas: any[];
}

export const KnowledgeGraphJsonLd: React.FC<IKnowledgeGraphJsonLdProps> = ({
  schemas,
}) => {
  if (!schemas || schemas.length === 0) {
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": schemas,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};
